import script from "./OtpSetup.vue?vue&type=script&lang=ts&setup=true"
export * from "./OtpSetup.vue?vue&type=script&lang=ts&setup=true"

import "./OtpSetup.vue?vue&type=style&index=0&id=48c459c4&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c459c4"]])

export default __exports__